<template>
  <v-app>
    <component :is="layout" v-if="!isShowDialogRole">
      <transition
        name="custom-classes-transition"
        enter-active-class="animated tada"
        leave-active-class="animated bounceOutRight"
      >
        <router-view />
      </transition>
    </component>

    <SelectAuthRole :value="isShowDialogRole" />

    <v-dialog v-model="getShowModal" persistent max-width="320">
      <v-card>
        <v-card-title class="headline d-flex justify-space-between w-100">
          <span>Внимание!</span>
          <v-icon size="25" @click="dialogClose">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text v-if="getPageName"
          >Для перехода на страницу <b>{{ getPageName }}</b> необходимо
          использовать полную версию сайта
        </v-card-text>
        <v-card-text v-else
          >Для перехода на данную страницу необходимо использовать полную версию
          сайта
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="getShowModalTrusty" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline d-flex justify-space-between w-100">
          <span>Ошибка!</span>
        </v-card-title>
        <v-card-text
          >Для авторизации в личном кабинете, необходимо иметь подтвержденную
          учетную запись.</v-card-text
        >
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="logout"
            >Вернуться на главную</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="getShowModalError" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline d-flex justify-space-between w-100">
          <span>Внимание!</span>
          <v-icon size="25" @click="getShowModalError = false">{{
            mdiClose
          }}</v-icon>
        </v-card-title>
        <v-card-text
          >Произошла непредвиденная ошибка. Попробуйте войти в систему
          позже.</v-card-text
        >
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '@/components/base/Header';
import Footer from '@/components/base/Footer';
import Default from '@/components/layouts/Default';
import Inner from '@/components/layouts/Inner';
import SelectAuthRole from '@/components/base/SelectAuthRole';
import Vue from 'vue';

import { AuthModule } from '@/store/modules/auth';
import { NotificationModule } from '@/store/modules/notifications.ts';
import { NotificationDocModule } from '@/store/modules/notificationsDocuments';
import { OtherModule } from '@/store/modules/other';
import { mdiClose } from '@mdi/js';
import { Layout } from '@/router';

export default Vue.extend({
  name: 'App',

  components: {
    Default,
    Footer,
    Header,
    Inner,
    SelectAuthRole,
  },
  computed: {
    layout() {
      return this.$route.meta.layout || Layout.DEFAULT;
    },
    isAuthenticated() {
      return AuthModule.isAuthenticated;
    },
    isShowDialogRole() {
      return AuthModule.isShowDialogRole;
    },
    getShowModal() {
      return OtherModule.showModalWindowFull;
    },

    getPageName() {
      return OtherModule.pageNameInModalWindowFull;
    },
  },

  data: () => ({
    dialog: true,
    mdiClose,
    getShowModalTrusty: false,
    getShowModalError: false,
  }),
  watch: {
    async isAuthenticated(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        await NotificationModule.getUserTopNotifications();
        await NotificationDocModule.getNotificationsDocNew();
      }
    },
  },
  created() {
    // используем window.location, т.к. $route еще не сформировался
    const query = window.location.search;
    this.getShowModalTrusty = false;
    this.getShowModalError = false;

    if (query && query.includes('auth=NonTrusty')) {
      this.getShowModalTrusty = true;
    }
    if (query && query.includes('auth=Error')) {
      this.getShowModalError = true;
    }
  },
  methods: {
    async dialogClose() {
      await OtherModule.onShowModalWindowFullReset(false);
    },
    logout() {
      AuthModule.logout();
    },
  },
});
</script>

<style lang="scss" src="./assets/styles/scss/main.scss"></style>
